import { AttendanceCode, AttendanceRegisterStatisticsResponse } from '@schooly/api';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

import {
  aggregateStatisticsByAgeGroup,
  getRegisterTotalJustificationCounts,
} from '../attendance-utils';
import { AttendanceStats } from '../AttendanceStatistics/AttendanceStats';
import { AttendanceRegisterPreviewAgeGroupsGrid } from './AttendanceRegisterPreviewAgeGroupsGrid';

interface AttendanceRegisterPreviewSessionsTabProps {
  register: AttendanceRegisterStatisticsResponse;
  codes: AttendanceCode[];
}

export const AttendanceRegisterPreviewSessionsTab: FC<
  AttendanceRegisterPreviewSessionsTabProps
> = ({ register, codes }) => {
  const { formatMessage } = useIntl();

  const { totalCounts, justificationCounts, ageGroups } = useMemo(() => {
    const ageGroups = aggregateStatisticsByAgeGroup(register);

    return {
      totalCounts: ageGroups.flatMap((ageGroup) => ageGroup.attendanceDetails),
      justificationCounts: getRegisterTotalJustificationCounts(
        ageGroups.map((ageGroup) => ageGroup.justificationCounts),
      ),
      ageGroups,
    };
  }, [register]);

  return (
    <>
      <AttendanceStats
        statistics={[{ counts: totalCounts, name: formatMessage({ id: 'attendance-Period' }) }]}
        justificationCounts={justificationCounts}
        showChartBars={false}
        sx={(theme) => ({
          mb: theme.spacing(1.5),
          '& .MuiCard-root': { border: 'none', flex: 1 },
        })}
      />

      <AttendanceRegisterPreviewAgeGroupsGrid codes={codes} ageGroups={ageGroups} />
    </>
  );
};
